import React from 'react';
import StateView from './StateView';
import './StatesView.css';


class StatesView extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
		   stateView: false
		}
	}


	toggleStateView() {
		if(this.state.stateView===false) {
			this.setState({
				stateView:true
			})
		}
		else {
			this.setState({
				stateView:false
			})
		}
	}

	render() {
		let cls = "StatesView";
		if(this.state.stateView===true) {
			cls = "StatesView active"
		}
		if(this.props.states.a.length>0) {
			return(
				<div className={cls}>
					<h5 className='boxName'
						onClick = 	{() => {
							this.toggleStateView() 
						}
					}
					>Bundesstaaten</h5>
					<div className='states-box'>
						{						
							this.props.states.a.map((v,i) => {
								return(
									<StateView  key = {i} 
										state = {v}
										parties = {this.props.parties}
										candidates = {this.props.candidates}
										show = {this.props.show}
										polls = {this.props.polls}
									></StateView>
								)
							})						
						}
					</div>
					{
						this.state.stateView === true &&
						<h5 className='boxName'
							onClick = 	{() => {
								this.toggleStateView() 
							}
						}
						>Bundesstaaten</h5>    						
					}
    
				</div>			
			)	
		}
		else {
			return false
		}
		
	}
}

export default StatesView
